import { put, select } from 'redux-saga/effects';

import { actionTypes as viewAT, getCurrentViewID } from 'store/view';
/**
 * Change view ID is its different than current
 */
export function* changeViewID(payload: { viewID: string }) {
	const currentViewID = yield select(getCurrentViewID);

	if (currentViewID !== payload.viewID) {
		yield put({
			type: viewAT.SAVE_VIEW_ID,
			viewID: payload.viewID,
		});

		yield put({
			type: viewAT.VIEW_ID_CHANGED,
		});
	}
}
